
import SecondaryButton from "../../components/SecondaryButton/SecondaryButton";
import { items } from "../../collectionsData";
import ItemCard from "../../components/ItemCard/ItemCard";

const UserProfile = () => {
    return (
        <div className='bg-white dark:bg-dark-content-bg dark:text-white transition-colors duration-300 ease-in-out'>
            <div className="max-w-[1600] mx-auto px-[5vw] lg:px-10 pb-20">

                <div className="flex flex-col md:flex-row justify-between items-center py-10">
                    <h1 className='m-2 xl:m-3 leading-60px md:leading-60px 2xl:leading-84px text-lg sm:text-50px md:text-xl lg:text-2xl xl:text-3xl 2xl:text-4xl font-bold '>
                        FX0121201's NFTs
                    </h1>
                    <div className="flex justify-center items-center">
                        <SecondaryButton title = {'NFTs'} className = 'm-2 xl:m-3 text-[10px] sm:text-[12px] xl:text-[14px] 2xl:text-base'/>
                        <SecondaryButton title = {'Offers Made'} className = 'm-2 xl:m-3 text-[10px] sm:text-[12px] xl:text-[14px] 2xl:text-base'/>
                        <SecondaryButton title = {'Recieved Offers'} className = 'm2 xl:m-3 text-[10px] sm:text-[12px] xl:text-[14px] 2xl:text-base'/>
                        <SecondaryButton title = {'Activity'} className = 'm-2 xl:m-3 text-[10px] sm:text-[12px] xl:text-[14px] 2xl:text-base'/>
                    </div>
                </div>


                <div className = "">
                    <p className='text-[#595959] dark:text-[#F2F2F2] font-medium text-base sm:text-lg mb-10'>
                        Collection
                    </p>

                    <div className="flex flex-col">

                        <div className="flex items-center mb-10">
                            <div className = 'w-[40px] h-[40px] mr-5'>
                                <img src = 'https://images.unsplash.com/photo-1547826039-bfc35e0f1ea8?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1072&q=80' 
                                    alt = 'collection' className = 'w-full h-full object-cover rounded-[50%]' />
                            </div>
                            <p className='text-center text-black dark:text-white font-medium text-base sm:text-lg border-b-[2px] border-main'>
                                Globe Keeper
                            </p>
                        </div>

                        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 2xl:grid-cols-6 gap-6 mb-20">
                            {items.map((item, index) => {
                                if(index < 8){
                                    return(
                                        <ItemCard item = {item} key = {index}/>
                                    )
                                }
                                else return null;
                            })}
                        </div>

                        <div className="flex items-center mb-10">
                            <div className = 'w-[40px] h-[40px] mr-5'>
                                <img src = 'https://images.unsplash.com/photo-1547826039-bfc35e0f1ea8?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1072&q=80' 
                                    alt = 'collection' className = 'w-full h-full object-cover rounded-[50%]' />
                            </div>
                            <p className='text-center text-black dark:text-white font-medium text-base sm:text-lg border-b-[2px] border-main'>
                                Score Praser
                            </p>
                        </div>

                        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 2xl:grid-cols-6 gap-6">
                            {items.map((item, index) => {
                                if(index > 4){
                                    return(
                                        <ItemCard item = {item} key = {index}/>
                                    )
                                }
                                else return null;
                            })}
                        </div>

                    </div>

                    

                </div>

            </div>
        </div>
    )
}

export default UserProfile;